import * as React from "react";
import Lead from "../../../../model/lead/Lead";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import InfoModule from "../../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {none, Option} from "ts-option";
import {default as DropDownList, DropDownItem} from "../../../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import DropDownWrapper from "../../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import TextUtils from "../../../../utils/TextUtils";
import Toast from "../../../helper/Toast";
import {editLead} from "../../../../store/action/lead/lead";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import DescriptionModal from "./DescriptionModal";
import UserMention from "../../../mention/UserMention";
import {IMentionData} from "react-mentions";
import {OnSuccess} from "../../../../store/action/actionHelpers";
import {api} from "../../../../api/api";
import MentionUtils from "../../../../utils/MentionUtils";
import _ = require("underscore");

interface ComponentProps {
	/**
	 * Lead.
	 */
	lead: Option<Lead>
}

interface IDispatchProps {
	/**
	 * Edit lead action.
	 * @param {Lead} lead
	 * @param {OnSuccess} onSuccess
	 */
	editLead: (lead: Lead, onSuccess: OnSuccess) => void;
}

interface IState {
	menuDropDownVisible: boolean;
	editBoxVisible: boolean;
}

type Props = ComponentProps & IDispatchProps

class Description extends React.PureComponent<Props, IState> {

	selectedDescriptionMenu: DropDownItem[] = [
		{id: "l1", label: "Change"},
		{id: "l2", label: "Remove"},
		{id: "l3", label: "Copy"},
	];

	emptyDescriptionMenu: DropDownItem[] = [
		{id: "l1", label: "Change"},
	];

	constructor(props: Props) {
		super(props);
		this.state = {
			menuDropDownVisible: false,
			editBoxVisible: false
		};
		this.toggleMenu = this.toggleMenu.bind(this);
		this.onMenuItemSelect = this.onMenuItemSelect.bind(this);
		this.onDescriptionChange = this.onDescriptionChange.bind(this);
	}

	render() {
		const menuItems = this.props.lead.isDefined && this.props.lead.get.data.description.isDefined ?
			this.selectedDescriptionMenu : this.emptyDescriptionMenu;
		return (
			<InfoModule icon={Icon.Description} title={"DESCRIPTION"} actionIcon={Icon.Overflow}
						onActionIconClick={this.toggleMenu}>
				{this.state.menuDropDownVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({menuDropDownVisible: false})}>
					<DropDownList items={menuItems}
								  itemToId={(link: DropDownItem) => link.id}
								  itemToLabel={(link: DropDownItem) => link.label}
								  onSelect={this.onMenuItemSelect}/>
				</DropDownWrapper>}
				{this.state.editBoxVisible &&
				<DescriptionModal value={this.props.lead.map(l => l.data.extendedDescription).getOrElse(none)}
								  onChange={(value, mentions) => this.setState({editBoxVisible: false},
									  () => {this.onDescriptionChange(value, mentions)})}
								  onClose={() => this.setState({editBoxVisible: false})}/>}
				{
					this.props.lead.map(l => {
						return (
							<span className="t-body">
								{l.data.extendedDescription.map(d => <UserMention value={d} readonly/>).getOrElse(
									<span>Description not provided</span>)}
							</span>
						)
					}).getOrElse(<span className="t-body">Description not provided</span>)
				}
			</InfoModule>
		);
	}

	onMenuItemSelect(item: DropDownItem) {
		this.setState({menuDropDownVisible: false});
		switch (item.id) {
			case "l1":
				this.setState({menuDropDownVisible: false, editBoxVisible: true});
				break;
			case "l2":
				this.setState({menuDropDownVisible: false, editBoxVisible: false},
					() => {this.onDescriptionChange(none, [])});
				break;
			case "l3":
				this.props.lead.map(c => c.data.description.map(d => TextUtils.copyToClipboard(d)));
				break;

		}
	}

	toggleMenu() {
		this.setState({menuDropDownVisible: !this.state.menuDropDownVisible})
	}

	onDescriptionChange(value: Option<string>, mentions: IMentionData[]) {
		this.props.lead.map(l => {
			const updatedLead = l.copy(
				{
					data: l.data.copy(
						{description: value.map(v => MentionUtils.getPlainText(v, true)), extendedDescription: value})
				});
			this.props.editLead(updatedLead, () => this.onLeadUpdateSuccess(mentions));
		})
	}

	onLeadUpdateSuccess(mentions: IMentionData[]) {
		Toast.success("Lead description updated", "Lead details update");
		this.mentionUsers(mentions);
	}

	private mentionUsers(mentions: IMentionData[]) {
		const uniqueUsers = _.uniq(mentions.map(m => m.id));
		if (uniqueUsers.length)
			this.props.lead.map(l =>
				api.instance.leadApi.mentionUsers(l.id, uniqueUsers).catch(() => Toast.error("Mention users error")));
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		editLead: (lead: Lead, onSuccess: OnSuccess) => dispatch(
			editLead(
				lead,
				onSuccess,
				() => Toast.error("Sorry, something went wrong. Try again later.", "Lead details update"))
		)
	}
}

export default connect(null, mapDispatchToProps)(Description)